var __assign = (this && this.__assign) || Object.assign || function(t) {
    for (var s, i = 1, n = arguments.length; i < n; i++) {
        s = arguments[i];
        for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
            t[p] = s[p];
    }
    return t;
};
// tslint:disable:max-line-length
// This file is generated by generateStyles script.
// Please don't edit it manually.
import * as React from "react";
import "../../less/svg/CloseBtn.less";
export var CloseBtn = function (props) { return (React.createElement("svg", { viewBox: "0 0 36 38.53" },
    React.createElement("defs", null),
    React.createElement("g", __assign({ id: "Layer_2" }, props, { className: "CloseBtn " + props.className }),
        React.createElement("g", { id: "Buttons" },
            React.createElement("circle", { className: "cls-1", cx: 18, cy: 20.53, r: 18 }),
            React.createElement("circle", { className: "cls-2", cx: 18, cy: 18, r: 17.5 }),
            React.createElement("path", { className: "cls-3", d: "M18 1A17 17 0 1 1 1 18 17 17 0 0 1 18 1m0-1a18 18 0 1 0 18 18A18 18 0 0 0 18 0z" }),
            React.createElement("path", { className: "cls-4", d: "M16 4.87a16 16 0 0 1 14.08 23.59 16 16 0 1 0-26.16-18A16 16 0 0 1 16 4.87z" }),
            React.createElement("path", { className: "cls-5", d: "M20.12 31.05a16 16 0 0 1-14-23.72A16 16 0 1 0 32 25.72a15.94 15.94 0 0 1-11.88 5.33z" }),
            React.createElement("path", { className: "cls-7", d: "M20.65 18l4.4-4.39a2.22 2.22 0 0 0 .39-3 2.22 2.22 0 0 0-3.05.39L18 15.35 13.61 11a2.22 2.22 0 0 0-3-.39 2.22 2.22 0 0 0 .39 3L15.35 18 11 22.39a2.22 2.22 0 0 0-.39 3.05 2.22 2.22 0 0 0 3-.39l4.39-4.4 4.39 4.4a2.22 2.22 0 0 0 3.05.39 2.22 2.22 0 0 0-.39-3.05z" }),
            React.createElement("ellipse", { id: "glow", className: "cls-6", cx: 23.93, cy: 7.33, rx: 1.59, ry: 3.46, transform: "rotate(-65.66 23.93 7.328)" }))))); };



//////////////////
// WEBPACK FOOTER
// ./src/assets/svg/CloseBtn.tsx
// module id = 1125
// module chunks = 3